<form [formGroup]="form" (ngSubmit)="onOkClicked()">

  <div class="pb-7 pt-0">
    @if (form && userSettings && !isLoading) {
      <p-tabs [(value)]="selectedTabValue">
        <p-tablist class="overflow-auto h-full">
          <p-tab [value]="0">
            <div class="flex align-items-center gap-2">
              <i class="pi pi pi-bell"></i>
              <span>{{'NOTIFICATIONS' | translate}}</span>
            </div>
          </p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel [value]="0">
            @if (notificationSettings?.length > 0) {
              <app-player-profile-settings-push-notification/>

              <div class="table-design">
                <table>
                  <tr>
                    <th class="text-center">{{'NOTIFICATION' | translate}}</th>
                    <th class="text-center">{{'SEND_MAIL' | translate}}</th>
                    @if (playerProfile?.fcmToken) {
                      <th class="text-center">{{'PUSH' | translate}}</th>
                    }
                  </tr>
                  @for (setting of notificationSettings; track i; let i = $index) {
                    <tr>
                      <td>
                        {{setting.label}}:
                      </td>
                      <td class="text-center">
                        @if (setting.key) {
                          <app-player-profile-settings-item [form]="form" [fieldName]="setting.fieldName"/>
                        }
                      </td>
                      @if (playerProfile?.fcmToken) {
                        <td class="text-center">
                          @if (setting.keyPush) {
                            <app-player-profile-settings-item [form]="form" [fieldName]="setting.fieldNamePush"/>
                          }
                        </td>
                      }
                    </tr>
                  }
                </table>
              </div>

              <!--<div class="pb-3 flex align-items-center underline font-bold">
                <div class="w-12rem">
                  {{'NOTIFICATION' | translate}}
                </div>
                <div class="w-7rem text-center">
                  {{'SEND_MAIL' | translate}}
                </div>
                @if (playerProfile?.fcmToken) {
                  <div class="w-7rem text-center">
                    {{'PUSH' | translate}}
                  </div>
                }
              </div>

              @for (notificationSetting of notificationSettings; track notificationSetting) {
                <app-notification-setting-item [setting]="notificationSetting" [form]="form"
                                               [showPush]="!!playerProfile?.fcmToken"/>
              }-->
            }
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    }

    @if (isLoading || errorMsg) {
      <div class="p-3">
        <app-loading [active]="isLoading"/>
        <app-message [active]="!!errorMsg" [message]="errorMsg"/>
      </div>
    }
  </div>

  <div class="dialog-footer flex">
    <app-dialog-button [loading]="isSaving"
                       (onOkClicked)="onOkClicked()"
                       (onCancelClicked)="onCancelClicked()"/>
  </div>
</form>
